import {
  LayoutTemplate,
  MousePointerClick,
  CalendarCheck,
  ClipboardList,
  Bot,
  ArrowUpRight,
} from "lucide-react";

const SERVICES = [
  {
    icon: LayoutTemplate,
    title: "Website Redesigns",
    desc: "Modernize your current website while keeping your brand identity intact.",
    span: "lg:col-span-3 lg:row-span-2",
  },
  {
    icon: MousePointerClick,
    title: "Landing Pages",
    desc: "Simple, focused pages designed to turn visitors into leads.",
    span: "lg:col-span-3",
  },
  {
    icon: CalendarCheck,
    title: "Booking & Contact Systems",
    desc: "Add forms, booking flows, and clear calls-to-action so customers can reach you faster.",
    span: "lg:col-span-3",
  },
  {
    icon: ClipboardList,
    title: "Business Website Audits",
    desc: "Quick reviews showing what can be improved on your current site.",
    span: "lg:col-span-3",
  },
  {
    icon: Bot,
    title: "AI Chatbot Integration",
    desc: "Optional chatbot features to help answer customer questions and capture leads.",
    span: "lg:col-span-3",
  },
];

export default function Services() {
  return (
    <section
      id="services"
      data-testid="services-section"
      className="relative py-24 md:py-32 border-t border-white/5"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6 mb-14">
          <div className="max-w-2xl">
            <span className="text-xs tracking-[0.22em] uppercase text-blue-400 font-medium">
              Services
            </span>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl tracking-tight font-semibold mt-4 leading-[1.1]">
              What I build to <span className="italic">help you grow</span>.
            </h2>
          </div>
          <p className="text-white/55 max-w-md text-sm md:text-base">
            Every service is built around one thing: turning visitors into
            calls, bookings, and paying customers.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-6 gap-5">
          {SERVICES.map((s, idx) => {
            const Icon = s.icon;
            const featured = idx === 0;
            return (
              <div
                key={s.title}
                data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "")}`}
                className={`group card-soft rounded-2xl p-7 md:p-8 transition-all duration-300 hover:-translate-y-1 ${s.span} ${
                  featured ? "bg-gradient-to-br from-blue-500/10 to-transparent" : ""
                }`}
              >
                <div className="flex items-start justify-between">
                  <div
                    className={`h-11 w-11 rounded-xl flex items-center justify-center border ${
                      featured
                        ? "border-blue-500/40 bg-blue-500/15 text-blue-300"
                        : "border-white/10 bg-white/[0.03] text-white/80"
                    }`}
                  >
                    <Icon size={20} />
                  </div>
                  <ArrowUpRight
                    size={18}
                    className="text-white/30 group-hover:text-white group-hover:translate-x-0.5 group-hover:-translate-y-0.5 transition-all"
                  />
                </div>

                <h3 className="font-display text-xl md:text-2xl mt-6 text-white">
                  {s.title}
                </h3>
                <p className="mt-3 text-sm md:text-[15px] text-white/55 leading-relaxed">
                  {s.desc}
                </p>

                {featured && (
                  <div className="hidden lg:flex mt-8 pt-6 border-t border-white/10 items-center gap-4 text-xs text-white/50">
                    <span className="px-2.5 py-1 rounded-full bg-white/5 border border-white/10">
                      Most requested
                    </span>
                    <span>Refresh without losing your brand.</span>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
